import base from './mario-base.svg';
import hat from './mario-hat.svg';
import eyes from './mario-eyes.svg';
import moustache from './mario-moustache.svg';
import friarCut from './mario-friarCut.svg';
import eyebrows from './mario-eyebrows.svg';
import bg from './mario-bg.svg';

export type ColorTransform =
  | { type: 'lighten'; amount: number }
  | { type: 'darken'; amount: number };

export interface ColorSchema {
  /**
   * Name of the colour to display to the user
   */
  name: string;
  /**
   * Source colour to replace within the original SVG
   */
  color: string;
  /**
   * Additional colours which will be replaced with transformed versions of the base colour
   */
  variants?: Array<{
    /**
     * A colour which will be replaced within the original SVG file
     */
    color: string;
    /**
     * The transformation which must be applied to the user-supplied base colour
     */
    operation: ColorTransform;
  }>;

  /**
   * The colour options presented to the user by default
   */
  suggestions?: string[];
}

export interface ItemSchema {
  id: string;
  default?: boolean;
  title: string;
  sortOrder: number;
  url: string;
  iconUrl: string;
  /**
   * List of user-configurable colours within the item
   */
  colors: Array<ColorSchema>;
}

const primaryColors = [
  '#468966',
  '#FFF0A5',
  '#FFB03B',
  '#B64926',
  '#8E2800',
  '#04BFBF',
  '#588F27',
];

export const GlobalColors: ItemSchema = {
  id: '_global',
  title: 'Global Colours',
  sortOrder: -1,
  url: '',
  iconUrl: '',
  colors: [
    {
      name: 'Skin',
      color: '#ffd090',
      variants: [
        {
          color: '#edbb7e',
          operation: {
            type: 'darken',
            amount: 0.5,
          },
        },
      ],
    },
    {
      name: 'Hair',
      color: '#502d16',
    },
  ],
};

// TODO: move this to a database, or auto-generate or something to make this more scalable!
export const ItemSchemas: Record<string, ItemSchema> = {
  background: {
    default: true,
    id: 'background',
    title: 'Background',
    sortOrder: 7,
    url: bg,
    iconUrl: bg,
    colors: [
      {
        name: 'Background',
        color: '#d61e1e',
        suggestions: primaryColors,
      },
    ],
  },
  base: {
    default: true,
    id: 'base',
    title: 'Head',
    sortOrder: 6,
    url: base,
    iconUrl: base,
    colors: [],
  },
  hat: {
    id: 'hat',
    title: 'Hat',
    sortOrder: 5,
    url: hat,
    iconUrl: hat,
    colors: [
      {
        name: 'Primary',
        color: '#d61e1e',
        suggestions: primaryColors,
        variants: [
          {
            color: '#b21818',
            operation: {
              type: 'darken',
              amount: 0.5,
            },
          },
        ],
      },
      {
        name: 'Icon',
        color: '#25b7d3',
        suggestions: primaryColors,
      },
    ],
  },
  eyes: {
    default: true,
    id: 'eyes',
    title: 'Eyes',
    sortOrder: 3,
    url: eyes,
    iconUrl: eyes,
    colors: [
      {
        name: 'Iris',
        color: '#d61e1e',
        suggestions: primaryColors,
      },
    ],
  },
  moustache: {
    id: 'moustache',
    title: 'Moustache',
    sortOrder: 2,
    url: moustache,
    iconUrl: moustache,
    colors: [],
  },
  'friar-cut': {
    id: 'friar-cut',
    title: 'Friar Haircut',
    sortOrder: 1,
    url: friarCut,
    iconUrl: friarCut,
    colors: [],
  },
  eyebrows: {
    default: true,
    id: 'eyebrows',
    title: 'Eyebrows',
    sortOrder: 0,
    url: eyebrows,
    iconUrl: eyebrows,
    colors: [],
  },
};
